module.exports = __webpack_public_path__ + "static/media/1 Locate Troopr Assistant in Slack.9bf5611e.svg";